export type AnalyticsClient = 'ieee' | 'asme';

export interface PageAnalyticsMetadata {
  pageName: string;
  pageCode: string;
}

export const PAGE_ANALYTICS: Record<AnalyticsClient, Record<string, PageAnalyticsMetadata>> = {
  ieee: {
    welcome: { pageName: 'Welcome', pageCode: 'New_IEEE_Welcome' },
    shortchecklist: { pageName: 'Short Checklist', pageCode: 'New_IEEE_Short_Checklist' },
    coverage: { pageName: 'Coverage Selection', pageCode: 'New_IEEE_Coverage_Selection' },
    entitytype: { pageName: 'Business Info', pageCode: 'New_IEEE_Business_Info' },
    revenue: { pageName: 'Revenue', pageCode: 'New_IEEE_Revenue' },
    practice: { pageName: 'Practice', pageCode: 'New_IEEE_Practice' },
    'projects-contracts': { pageName: 'Projects & Contracts', pageCode: 'New_IEEE_Projects_Contracts' },
    'prior-insurance-details': { pageName: 'Prior Insurance Details', pageCode: 'New_IEEE_Prior_Insurance_Details' },
    'claims-licensing': { pageName: 'Claims & Licensing', pageCode: 'New_IEEE_Claims_Licensing' },
    'claim-info-supplement': { pageName: 'Claim Information Supplement', pageCode: 'New_IEEE_Claim_Information_Supplement' },
    'risk-practice-questionsone': { pageName: 'Risk Practice Questions (1 of 2)', pageCode: 'New_IEEE_Risk_Practice_Questions_One' },
    'risk-practice-questionstwo': { pageName: 'Risk Practice Questions (2 of 2)', pageCode: 'New_IEEE_Risk_Practice_Questions_Two' },
    'computer-services-supplement': { pageName: 'Computer Services Supplement', pageCode: 'New_IEEE_Computer_Services_Supplement' },
    'review-sign': { pageName: 'Review & Sign', pageCode: 'New_IEEE_Review_Sign' },
    thankyou: { pageName: 'Thank You', pageCode: 'New_IEEE_Thank_You' },
  },
  asme: {
    welcome: { pageName: 'Welcome', pageCode: 'New_ASME_Welcome' },
    shortchecklist: { pageName: 'Short Checklist', pageCode: 'New_ASME_Short_Checklist' },
    coverage: { pageName: 'Coverage Selection', pageCode: 'New_ASME_Coverage_Selection' },
    entitytype: { pageName: 'Business Info', pageCode: 'New_ASME_Business_Info' },
    revenue: { pageName: 'Revenue', pageCode: 'New_ASME_Revenue' },
    practice: { pageName: 'Practice', pageCode: 'New_ASME_Practice' },
    'projects-contracts': { pageName: 'Projects & Contracts', pageCode: 'New_ASME_Projects_Contracts' },
    'prior-insurance-details': { pageName: 'Prior Insurance Details', pageCode: 'New_ASME_Prior_Insurance_Details' },
    'claims-licensing': { pageName: 'Claims & Licensing', pageCode: 'New_ASME_Claims_Licensing' },
    'claim-info-supplement': { pageName: 'Claim Information Supplement', pageCode: 'New_ASME_Claim_Information_Supplement' },
    'risk-practice-questionsone': { pageName: 'Risk Practice Questions (1 of 2)', pageCode: 'New_ASME_Risk_Practice_Questions_One' },
    'risk-practice-questionstwo': { pageName: 'Risk Practice Questions (2 of 2)', pageCode: 'New_ASME_Risk_Practice_Questions_Two' },
    'review-sign': { pageName: 'Review & Sign', pageCode: 'New_ASME_Review_Sign' },
    thankyou: { pageName: 'Thank You', pageCode: 'New_ASME_Thank_You' },
  },
};